import { useEffect, useRef } from "react";
import { IS_CF } from "@/lib/api";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
export const NEEDS_CAPTCHA = IS_CF && Boolean(SITE_KEY);

let loader;
const loadScript = () => {
  loader ??= new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.onload = () => resolve(window.turnstile);
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return loader;
};

// Cloudflare Turnstile widget. Tokens are single-use: change `key` on the parent to get a new one.
export const Turnstile = ({ onToken, testId = "turnstile-widget" }) => {
  const box = useRef(null);
  useEffect(() => {
    if (!NEEDS_CAPTCHA) return undefined;
    let id;
    let alive = true;
    loadScript().then((ts) => {
      if (!alive || !box.current) return;
      id = ts.render(box.current, {
        sitekey: SITE_KEY,
        callback: (tok) => onToken(tok),
        "expired-callback": () => onToken(""),
        "error-callback": () => onToken(""),
      });
    }).catch(() => onToken(""));
    return () => {
      alive = false;
      if (id !== undefined) window.turnstile?.remove(id);
    };
  }, [onToken]);
  if (!NEEDS_CAPTCHA) return null;
  return <div ref={box} className="min-h-[65px]" data-testid={testId} />;
};
